module.exports = __webpack_public_path__ + "img/centra.f2455bba.webp";